<template>
  <router-view />
</template>

<style> 
  /* #nav {
    padding: 30px;
  } */
#nav a {
  font-weight: bold;
  color:  #002F6C;
}
#nav a.router-link-exact-active {
  color: #002F6C;
}
</style>
